import {
  GET_PRODUCTVARIAN,
  GET_PRODUCTVARIAN_SUCCESS,
  GET_PRODUCTVARIAN_FAIL,
  DELETE_PRODUCTVARIAN,
  DELETE_PRODUCTVARIAN_SUCCESS,
  DELETE_PRODUCTVARIAN_FAIL,
  UPDATE_PRODUCTVARIAN,
  UPDATE_PRODUCTVARIAN_SUCCESS,
  UPDATE_PRODUCTVARIAN_FAIL,
  ADD_NEW_PRODUCTVARIAN,
  ADD_PRODUCTVARIAN_SUCCESS,
  ADD_PRODUCTVARIAN_FAIL,
  PRODUCTVARIAN_LOADING,
  PRODUCTVARIAN_RESET,
} from "./actionType";

export const resetProductVarianState = (actionType) => ({
  type: PRODUCTVARIAN_RESET,
  payload: { actionType },
});

export const getProductVarianSuccess = (actionType, data) => ({
  type: GET_PRODUCTVARIAN_SUCCESS,
  payload: { actionType, data },
});

export const getProductVarianFail = (actionType, error) => ({
  type: GET_PRODUCTVARIAN_FAIL,
  payload: { actionType, error },
});

export const getProductVarian = data => ({
  type: GET_PRODUCTVARIAN,
  payload: data,
});

export const getProductVarianLoading = () => ({
  type: PRODUCTVARIAN_LOADING
});

export const deleteProductVarian = data => ({
  type: DELETE_PRODUCTVARIAN,
  payload: data,
});

export const deleteProductVarianSuccess = data => ({
  type: DELETE_PRODUCTVARIAN_SUCCESS,
  payload: data,
});

export const deleteProductVarianFail = error => ({
  type: DELETE_PRODUCTVARIAN_FAIL,
  payload: error,
});

export const updateProductVarian = data => ({
  type: UPDATE_PRODUCTVARIAN,
  payload: data,
});

export const updateProductVarianFail = error => ({
  type: UPDATE_PRODUCTVARIAN_FAIL,
  payload: error,
});

export const updateProductVarianSuccess = data => ({
  type: UPDATE_PRODUCTVARIAN_SUCCESS,
  payload: data,
});

export const addNewProductVarian = data => ({
  type: ADD_NEW_PRODUCTVARIAN,
  payload: data,
});

export const addProductVarianSuccess = data => ({
  type: ADD_PRODUCTVARIAN_SUCCESS,
  payload: data,
});

export const addProductVarianFail = error => ({
  type: ADD_PRODUCTVARIAN_FAIL,
  payload: error,
});